export * from './delete-datei-art.service';
export * from './delete-datei-art.service.module';